var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDvirTemplate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 22H2C0.9 22 0 21.1 0 20V6H2V20H16V22ZM12.5 6V4H10.5V6H8.5V8H10.5V10H12.5V8H14.5V6H12.5ZM14.5 12H8.5V14H14.5V12ZM13 0H6C4.9 0 4.01 0.9 4.01 2L4 16C4 17.1 4.89 18 5.99 18H17C18.1 18 19 17.1 19 16V6L13 0ZM17 16H6V2H12.17L17 6.83V16Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDvirTemplate);
export default __webpack_public_path__ + "static/media/dvirTemplate.51a0b65f254ed052a8763a584c175d8c.svg";
export { ForwardRef as ReactComponent };